<template>
  <!-- On a test site only: a strip across the top so it is never taken for the live app -->
  <v-system-bar v-if="IS_TEST_SITE" color="warning" class="justify-center font-weight-bold">
    TEST SITE — not real data · the live app is {{ LIVE_HOST }}
  </v-system-bar>
</template>

<script setup>
import { IS_TEST_SITE, LIVE_HOST } from "@/utils/testSite.js";
</script>
